import React, { useEffect, useState } from 'react'
import { KnowledgeSaleDesc, StationKnowledgeSaleWrapper } from './StationKnowledgeUglyStyled'
import {
  ButtonGradient,
  ButtonGradientWrapper,
  CampaignContentText,
  CenterDiv,
  CircleBackground,
  Container,
  TextGradient,
  TextGradientWrapper,
} from '../CommonStyled/CommonStyled'
import KnowledgeCenterBox from '../KnowledgeCenterBox'
import KnowledgeAroundBox from '../KnowledgeAroundBox'
import IMAGES from '../../images'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { BREAKPOINT, PAGES, REGISTER_ID, VIEW_MODE } from '../../constant'
import { useNavigate } from 'react-router-dom'
import config from '../../config'
import ScrollHeightBase from '../ScrollHeightBase'
import { Modal } from 'antd'
import KnowledgeCenterBoxUgly from '../KnowledgeCenterBoxUgly'
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml'
import VideoYoutube from '../VideoYoutube/VideoYoutube'
import { buildPath } from '../../utils/common'

const StationKnowledgeUgly = props => {
  const { knowledgeData, mode } = props
  const navigate = useNavigate()
  const breakPoint = useRecoilValue(breakPointState)

  const [openModal, setOpenModal] = useState(false)
  const [dataModal, setDataModal] = useState(null)
  const [topLeftData, setTopLeftData] = useState({
    image: buildPath(knowledgeData?.featureConfig?.featureInformationList[0]?.commonImage),
    label: <>{knowledgeData?.featureConfig?.featureInformationList[0]?.commonTitle}</>,
    content: (
      <>
        <TextGradientWrapper>
          <TextGradient>{knowledgeData?.featureConfig?.featureInformationList[0]?.detailTitle}</TextGradient>
        </TextGradientWrapper>
        <CenterDiv>
          {
            knowledgeData?.featureConfig?.featureInformationList[0]?.showEmbedLink
              ? <VideoYoutube linkEmbed={knowledgeData?.featureConfig?.featureInformationList[0]?.embedLink} />
              : knowledgeData?.featureConfig?.featureInformationList[0]?.detailImage && (
              <img
                src={buildPath(knowledgeData?.featureConfig?.featureInformationList[0]?.detailImage)}
                width={'auto'}
                style={{ maxWidth: '100%' }}
                alt={'event'}
              />
            )
          }
        </CenterDiv>
        <CampaignContentText>
          <DangerouslySetInnerHtml html={knowledgeData?.featureConfig?.featureInformationList[0]?.detailDescription} />
        </CampaignContentText>
      </>
    ),
  })
  const [bottomLeftData, setBottomLeftData] = useState({
    image: buildPath(knowledgeData?.featureConfig?.featureInformationList[1]?.commonImage),
    label: <>{knowledgeData?.featureConfig?.featureInformationList[1]?.commonTitle}</>,
    content: (
      <>
        <TextGradientWrapper>
          <TextGradient>{knowledgeData?.featureConfig?.featureInformationList[1]?.detailTitle}</TextGradient>
        </TextGradientWrapper>
        <CenterDiv>
          {
            knowledgeData?.featureConfig?.featureInformationList[1]?.showEmbedLink
              ? <VideoYoutube linkEmbed={knowledgeData?.featureConfig?.featureInformationList[1]?.embedLink} />
              : knowledgeData?.featureConfig?.featureInformationList[1]?.detailImage && (
              <img
                src={buildPath(knowledgeData?.featureConfig?.featureInformationList[1]?.detailImage)}
                width={'auto'}
                style={{ maxWidth: '100%' }}
                alt={'event'}
              />
            )
          }
        </CenterDiv>
        <CampaignContentText>
          <DangerouslySetInnerHtml html={knowledgeData?.featureConfig?.featureInformationList[1]?.detailDescription} />
        </CampaignContentText>
      </>
    ),
  })
  const [topRightData, setTopRightData] = useState({
    image: buildPath(knowledgeData?.featureConfig?.featureInformationList[2]?.commonImage),
    label: <>{knowledgeData?.featureConfig?.featureInformationList[2]?.commonTitle}</>,
    content: (
      <>
        <TextGradientWrapper>
          <TextGradient>{knowledgeData?.featureConfig?.featureInformationList[2]?.detailTitle}</TextGradient>
        </TextGradientWrapper>
        <CenterDiv>
          {
            knowledgeData?.featureConfig?.featureInformationList[2]?.showEmbedLink
              ? <VideoYoutube linkEmbed={knowledgeData?.featureConfig?.featureInformationList[2]?.embedLink} />
              : knowledgeData?.featureConfig?.featureInformationList[2]?.detailImage && (
              <img
                src={buildPath(knowledgeData?.featureConfig?.featureInformationList[2]?.detailImage)}
                width={'auto'}
                style={{ maxWidth: '100%' }}
                alt={'event'}
              />
            )
          }
        </CenterDiv>
        <CampaignContentText>
          <DangerouslySetInnerHtml html={knowledgeData?.featureConfig?.featureInformationList[2]?.detailDescription} />
        </CampaignContentText>
      </>
    ),
  })
  const [bottomRightData, setBottomRightData] = useState({
    image: buildPath(knowledgeData?.featureConfig?.featureInformationList[3]?.commonImage),
    label: <>{knowledgeData?.featureConfig?.featureInformationList[3]?.commonTitle}</>,
    content: (
      <>
        <TextGradientWrapper>
          <TextGradient>{knowledgeData?.featureConfig?.featureInformationList[3]?.detailTitle}</TextGradient>
        </TextGradientWrapper>
        <CenterDiv>
          {
            knowledgeData?.featureConfig?.featureInformationList[3]?.showEmbedLink
              ? <VideoYoutube linkEmbed={knowledgeData?.featureConfig?.featureInformationList[3]?.embedLink} />
              : knowledgeData?.featureConfig?.featureInformationList[3]?.detailImage && (
              <img
                src={buildPath(knowledgeData?.featureConfig?.featureInformationList[3]?.detailImage)}
                width={'auto'}
                style={{ maxWidth: '100%' }}
                alt={'event'}
              />
            )
          }
        </CenterDiv>
        <CampaignContentText>
          <DangerouslySetInnerHtml html={knowledgeData?.featureConfig?.featureInformationList[3]?.detailDescription} />
        </CampaignContentText>
      </>
    ),
  })
  const [direction, setDirection] = useState({ top: false, right: false, bottom: false, left: false })
  const [configKnowledge, setConfigKnowledge] = useState({
    cirCleBg: {
      height: 'auto',
      padding: '32px 0',
    },
    container: {
      flexDirection: 'column',
    },
    knowledge: {
      topLeft: { top: '2%', right: 'auto', bottom: 'auto', left: '11%' },
      bottomLeft: { top: 'auto', right: 'auto', bottom: '20%', left: '18%' },
      center: { top: '44%', right: 'auto', bottom: 'auto', left: '50%' },
      topRight: { top: '2%', right: '11%', bottom: 'auto', left: 'auto' },
      bottomRight: { top: 'auto', right: '18%', bottom: '20%', left: 'auto' },
    },
  })


  const handleClickAround = position => {
    switch (position) {
      case 'TOP_LEFT':
        setDataModal(topLeftData.content)
        break
      case 'BOTTOM_LEFT':
        setDataModal(bottomLeftData.content)
        break
      case 'TOP_RIGHT':
        setDataModal(topRightData.content)
        break
      case 'BOTTOM_RIGHT':
        setDataModal(bottomRightData.content)
        break
      default:
        break
    }
    setOpenModal(true)
  }

  const handleClickRegister = () => {
    switch (mode) {
      case VIEW_MODE.PREVIEW:
        window.open(`${config.basePath}${PAGES.REGISTER_PREVIEW_SME.PATH}/${REGISTER_ID.KNOWLEDGE}`, '_blank')
        break
      case VIEW_MODE.PUBLIC:
        window.open(`${config.basePath}${PAGES.REGISTER_SME.PATH}/${REGISTER_ID.KNOWLEDGE}`, '_blank')
        break
      default:
        break
    }
  }

  useEffect(() => {
    let newConfig = { ...configKnowledge }
    switch (breakPoint) {
      case BREAKPOINT.XS:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '2%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '7%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '5%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '10%', bottom: '20%', left: 'auto' }
        break
      case BREAKPOINT.SM:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '2%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '7%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '5%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '10%', bottom: '20%', left: 'auto' }
        break
      case BREAKPOINT.MD:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '2%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '7%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '5%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '10%', bottom: '20%', left: 'auto' }
        break
      case BREAKPOINT.LG:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '2%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '7%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '5%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '10%', bottom: '20%', left: 'auto' }
        break
      case BREAKPOINT.XL:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '2%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '7%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '5%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '10%', bottom: '20%', left: 'auto' }
        break
      case BREAKPOINT.XXL:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '11%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '18%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '11%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '18%', bottom: '20%', left: 'auto' }
        break
      default:
        newConfig.cirCleBg.height = 'auto'
        newConfig.cirCleBg.padding = '32px 0'
        newConfig.container.flexDirection = 'column'
        newConfig.knowledge.topLeft = { top: '2%', right: 'auto', bottom: 'auto', left: '11%' }
        newConfig.knowledge.bottomLeft = { top: 'auto', right: 'auto', bottom: '20%', left: '18%' }
        newConfig.knowledge.center = { top: '44%', right: 'auto', bottom: 'auto', left: '50%' }
        newConfig.knowledge.topRight = { top: '2%', right: '11%', bottom: 'auto', left: 'auto' }
        newConfig.knowledge.bottomRight = { top: 'auto', right: '18%', bottom: '20%', left: 'auto' }
        break
    }
    setConfigKnowledge(newConfig)
  }, [breakPoint])

  return (
    <StationKnowledgeSaleWrapper>
      <CircleBackground height={configKnowledge.cirCleBg.height} padding={configKnowledge.cirCleBg.padding}>
        <Container display={'flex'} flexDirection={'column'}>
          <KnowledgeAroundBox
            data={topLeftData}
            position={configKnowledge.knowledge.topLeft}
            direction={direction}
            callBackClick={() => handleClickAround('TOP_LEFT')}
          />
          <KnowledgeAroundBox
            data={bottomLeftData}
            position={configKnowledge.knowledge.bottomLeft}
            direction={direction}
            callBackClick={() => handleClickAround('BOTTOM_LEFT')}
          />
          <KnowledgeCenterBoxUgly />
          <KnowledgeAroundBox
            data={topRightData}
            position={configKnowledge.knowledge.topRight}
            direction={direction}
            callBackClick={() => handleClickAround('TOP_RIGHT')}
          />
          <KnowledgeAroundBox
            data={bottomRightData}
            position={configKnowledge.knowledge.bottomRight}
            direction={direction}
            callBackClick={() => handleClickAround('BOTTOM_RIGHT')}
          />

          <KnowledgeSaleDesc>{knowledgeData?.featureConfig?.commonDescription}</KnowledgeSaleDesc>
          {knowledgeData?.registerButton?.show && (
            <ButtonGradientWrapper margin={'24px 0 0 0'}>
              <ButtonGradient onClick={handleClickRegister}>{knowledgeData?.registerButton?.buttonText}</ButtonGradient>
            </ButtonGradientWrapper>
          )}
        </Container>
      </CircleBackground>
      <Modal
        open={openModal}
        footer={null}
        onCancel={() => {
          setDataModal(null)
          setOpenModal(false)
        }}
        width={'80%'}
        title={''}
        style={{ top: 64 }}
      >
        <ScrollHeightBase height={'calc(100vh - 160px)'}>{dataModal}</ScrollHeightBase>
      </Modal>
    </StationKnowledgeSaleWrapper>
  )
}

export default StationKnowledgeUgly
